"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Action = _interopRequireDefault(require("../model/Action"));

var _ActionCreateRequest = _interopRequireDefault(require("../model/ActionCreateRequest"));

var _ActionList = _interopRequireDefault(require("../model/ActionList"));

var _ActionTypeEnum = _interopRequireDefault(require("../model/ActionTypeEnum"));

var _ActionUpdateRequest = _interopRequireDefault(require("../model/ActionUpdateRequest"));

var _AvailableAction = _interopRequireDefault(require("../model/AvailableAction"));

var _AvailableActionList = _interopRequireDefault(require("../model/AvailableActionList"));

var _Errors = _interopRequireDefault(require("../model/Errors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Actions service.
* @module api/ActionsApi
* @version 1.126
*/
var ActionsApi = /*#__PURE__*/function () {
  /**
  * Constructs a new ActionsApi. 
  * @alias module:api/ActionsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function ActionsApi(apiClient) {
    _classCallCheck(this, ActionsApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Create a new purchase order action
   * **scope**: actions:write 
   * @param {Object} opts Optional parameters
   * @param {module:model/ActionCreateRequest} opts.actionCreateRequest The payload to use to create the new purchase order action
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Action} and HTTP response
   */


  _createClass(ActionsApi, [{
    key: "appApisV1ActionsCreateActionWithHttpInfo",
    value: function appApisV1ActionsCreateActionWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['actionCreateRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Action["default"];
      return this.apiClient.callApi('/actions', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a new purchase order action
     * **scope**: actions:write 
     * @param {Object} opts Optional parameters
     * @param {module:model/ActionCreateRequest} opts.actionCreateRequest The payload to use to create the new purchase order action
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Action}
     */

  }, {
    key: "appApisV1ActionsCreateAction",
    value: function appApisV1ActionsCreateAction(opts) {
      return this.appApisV1ActionsCreateActionWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete a purchase order action
     * **scope**: actions:admin 
     * @param {String} actionUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ActionsDeleteActionWithHttpInfo",
    value: function appApisV1ActionsDeleteActionWithHttpInfo(actionUuid) {
      var postBody = null; // verify the required parameter 'actionUuid' is set

      if (actionUuid === undefined || actionUuid === null) {
        throw new Error("Missing the required parameter 'actionUuid' when calling appApisV1ActionsDeleteAction");
      }

      var pathParams = {
        'action_uuid': actionUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/actions/{action_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete a purchase order action
     * **scope**: actions:admin 
     * @param {String} actionUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ActionsDeleteAction",
    value: function appApisV1ActionsDeleteAction(actionUuid) {
      return this.appApisV1ActionsDeleteActionWithHttpInfo(actionUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a purchase order action
     * **scope**: actions:read 
     * @param {String} actionUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Action} and HTTP response
     */

  }, {
    key: "appApisV1ActionsGetActionWithHttpInfo",
    value: function appApisV1ActionsGetActionWithHttpInfo(actionUuid) {
      var postBody = null; // verify the required parameter 'actionUuid' is set

      if (actionUuid === undefined || actionUuid === null) {
        throw new Error("Missing the required parameter 'actionUuid' when calling appApisV1ActionsGetAction");
      }

      var pathParams = {
        'action_uuid': actionUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Action["default"];
      return this.apiClient.callApi('/actions/{action_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a purchase order action
     * **scope**: actions:read 
     * @param {String} actionUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Action}
     */

  }, {
    key: "appApisV1ActionsGetAction",
    value: function appApisV1ActionsGetAction(actionUuid) {
      return this.appApisV1ActionsGetActionWithHttpInfo(actionUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve an available purchase order action from the database
     * **scope**: available-actions:read 
     * @param {String} actionUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AvailableAction} and HTTP response
     */

  }, {
    key: "appApisV1ActionsGetAvailableActionWithHttpInfo",
    value: function appApisV1ActionsGetAvailableActionWithHttpInfo(actionUuid) {
      var postBody = null; // verify the required parameter 'actionUuid' is set

      if (actionUuid === undefined || actionUuid === null) {
        throw new Error("Missing the required parameter 'actionUuid' when calling appApisV1ActionsGetAvailableAction");
      }

      var pathParams = {
        'action_uuid': actionUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AvailableAction["default"];
      return this.apiClient.callApi('/available-actions/{action_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve an available purchase order action from the database
     * **scope**: available-actions:read 
     * @param {String} actionUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AvailableAction}
     */

  }, {
    key: "appApisV1ActionsGetAvailableAction",
    value: function appApisV1ActionsGetAvailableAction(actionUuid) {
      return this.appApisV1ActionsGetAvailableActionWithHttpInfo(actionUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a paginated list of purchase order actions
     * **scope**: actions:read 
     * @param {Object} opts Optional parameters
     * @param {module:model/ActionTypeEnum} opts.actionType 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ActionList} and HTTP response
     */

  }, {
    key: "appApisV1ActionsListActionsWithHttpInfo",
    value: function appApisV1ActionsListActionsWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'action_type': opts['actionType'],
        'page': opts['page'],
        'per_page': opts['perPage']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ActionList["default"];
      return this.apiClient.callApi('/actions', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a paginated list of purchase order actions
     * **scope**: actions:read 
     * @param {Object} opts Optional parameters
     * @param {module:model/ActionTypeEnum} opts.actionType 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ActionList}
     */

  }, {
    key: "appApisV1ActionsListActions",
    value: function appApisV1ActionsListActions(opts) {
      return this.appApisV1ActionsListActionsWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a list of available actions to be used within an action plan
     * **scope**: available-actions:read 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AvailableActionList} and HTTP response
     */

  }, {
    key: "appApisV1ActionsListAvailableActionsWithHttpInfo",
    value: function appApisV1ActionsListAvailableActionsWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AvailableActionList["default"];
      return this.apiClient.callApi('/available-actions', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a list of available actions to be used within an action plan
     * **scope**: available-actions:read 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AvailableActionList}
     */

  }, {
    key: "appApisV1ActionsListAvailableActions",
    value: function appApisV1ActionsListAvailableActions(opts) {
      return this.appApisV1ActionsListAvailableActionsWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a purchase order action
     * **scope**: actions:write 
     * @param {String} actionUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ActionUpdateRequest} opts.actionUpdateRequest The payload to use to update the purchase order action
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Action} and HTTP response
     */

  }, {
    key: "appApisV1ActionsUpdateActionWithHttpInfo",
    value: function appApisV1ActionsUpdateActionWithHttpInfo(actionUuid, opts) {
      opts = opts || {};
      var postBody = opts['actionUpdateRequest']; // verify the required parameter 'actionUuid' is set

      if (actionUuid === undefined || actionUuid === null) {
        throw new Error("Missing the required parameter 'actionUuid' when calling appApisV1ActionsUpdateAction");
      }

      var pathParams = {
        'action_uuid': actionUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Action["default"];
      return this.apiClient.callApi('/actions/{action_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a purchase order action
     * **scope**: actions:write 
     * @param {String} actionUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ActionUpdateRequest} opts.actionUpdateRequest The payload to use to update the purchase order action
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Action}
     */

  }, {
    key: "appApisV1ActionsUpdateAction",
    value: function appApisV1ActionsUpdateAction(actionUuid, opts) {
      return this.appApisV1ActionsUpdateActionWithHttpInfo(actionUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return ActionsApi;
}();

exports["default"] = ActionsApi;